module.exports = __webpack_public_path__ + "img/cream.66f15153.png";